import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearVisitAction, getVisitAction } from '../../redux/actions/visitActions';

const useFetchVisit = (visitId, vin) => {
  const dispatch = useDispatch();
  const visit = useSelector((state) => state.visit?.visit);
  const loading = useSelector((state) => state.visit?.loading);

  const fetchVisit = useCallback(async () => {
    await dispatch(getVisitAction(visitId, vin));
  }, [visitId, vin, dispatch]);

  useEffect(() => {
    fetchVisit();
  }, [fetchVisit]);

  useEffect(() => {
    return () => {
      dispatch(clearVisitAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchVisit();
  };

  return { loading, visit, refresh };
};

export default useFetchVisit;
